
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[courseName]",
      function () {
        return require("private-next-pages/[courseName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[courseName]"])
      });
    }
  